import type { DesignVersion } from '@fluentui-copilot/react-provider';
import type { ComponentProps, ComponentState, Slot, BadgeProps } from '@fluentui/react-components';

/**
 * @deprecated Use PromptStarterV2 instead.
 * Deprecated on 10/21/2025
 */
export type PromptStarterSlots = {
  root: Slot<'button'>;
  icon: NonNullable<Slot<'span'>>;
  category: NonNullable<Slot<'span'>>;
  prompt?: Slot<'span'>;
  badge?: Slot<BadgeProps>;
};

/**
 * PromptStarter Props
 * @deprecated Use PromptStarterV2 instead.
 * Deprecated on 10/21/2025
 */
export type PromptStarterProps = ComponentProps<PromptStarterSlots> & DesignVersion & {};

/**
 * State used in rendering PromptStarter
 * @deprecated Use PromptStarterV2 instead.
 * Deprecated on 10/21/2025
 */
export type PromptStarterState = ComponentState<PromptStarterSlots> &
  Pick<Required<PromptStarterProps>, 'designVersion'>;
